import { render, staticRenderFns } from "./SpeGroup.vue?vue&type=template&id=124b87ac&scoped=true&"
import script from "./SpeGroup.vue?vue&type=script&lang=js&"
export * from "./SpeGroup.vue?vue&type=script&lang=js&"
import style0 from "./SpeGroup.vue?vue&type=style&index=0&id=124b87ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124b87ac",
  null
  
)

export default component.exports